import * as Service from "VSS/Service";
import { HubsService } from "VSS/Navigation/HubsService";
import * as UrlUtils from "WorkItemsHub/Scripts/Utils/UrlUtils";
import { FastPageSwitch } from "VSS/Platform/FPS"
import { IVssPageContext } from "VSS/Platform/Context";
import { getWorkItemsHubId } from "WorkItemTracking/Scripts/Utils/WorkItemsHubIdHelper";

/**
 * Navigate to work item hub without page refresh.
 */
export function navigateToWorkItemHub(pageContext?: IVssPageContext): void {
    const wihUrl = UrlUtils.getWorkItemHubUrl();

    if (pageContext) {
        FastPageSwitch(pageContext, wihUrl, true);
    }
    else {
        Service.getLocalService(HubsService).navigateToHub(getWorkItemsHubId(), wihUrl);
    }
}

/**
 * Replaces the current hub state with state for edit work item.
 */
export function replaceHubStateWithEditWorkItem(workItemId: number): void {
    Service.getLocalService(HubsService).replaceCurrentHubState(getWorkItemsHubId(), UrlUtils.getEditWorkItemUrl(workItemId));
}
